var _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "visibilityIcon",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 4C3.25 4 1 10 1 10C1 10 3.25 16 9.25 16C15.25 16 17.5 10 17.5 10C17.5 10 15.25 4 9.25 4ZM9.25 5.5C13.207 5.5 15.2084 8.70032 15.8564 9.99707C15.2077 11.2848 13.1913 14.5 9.25 14.5C5.293 14.5 3.29155 11.2997 2.64355 10.0029C3.29305 8.71518 5.30875 5.5 9.25 5.5ZM9.25 7C7.59325 7 6.25 8.34325 6.25 10C6.25 11.6568 7.59325 13 9.25 13C10.9068 13 12.25 11.6568 12.25 10C12.25 8.34325 10.9068 7 9.25 7ZM9.25 8.5C10.0788 8.5 10.75 9.17125 10.75 10C10.75 10.8288 10.0788 11.5 9.25 11.5C8.42125 11.5 7.75 10.8288 7.75 10C7.75 9.17125 8.42125 8.5 9.25 8.5Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.363,
    y1: 0.343872,
    x2: 0.362976,
    y2: 19.3439,
    stroke: "#555770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOffIcon);
export default __webpack_public_path__ + "static/media/visibilityOffIcon.41d4903f3b76c0d145fc6663c587b6d1.svg";
export { ForwardRef as ReactComponent };